import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideSectionForm from '../containers/CareGuideSectionFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideSectionAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideSectionAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_section_route_add')} />
          <CareGuideSectionForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideSectionAddScreen;

Logger.log('silly', `CareGuideSectionAddScreen loaded.`);
